"use client";
import React from "react";
import Image from "components/common/Image";
import { APP_QR_IMAGE } from "utils/constant";
import { useT } from "providers/I18nProvider";

interface AppQRCodeProps {
  /** Tailwind size class của khung, vd "w-32 h-32" */
  sizeClassName?: string;
}

/** Khung QR tải app dùng chung (SectionDownloadApp, BookingQRModal) */
const AppQRCode: React.FC<AppQRCodeProps> = ({
  sizeClassName = "w-32 h-32",
}) => {
  const t = useT();
  return (
    <div
      className={`${sizeClassName} bg-white rounded-2xl shadow-lg flex items-center justify-center border-2 border-dashed border-gray-300`}
    >
      <Image
        isRelative={true}
        src={APP_QR_IMAGE}
        alt={t("appQRCode.alt")}
        wrapClassName="relative w-full aspect-[1/1] rounded-2xl object-contain overflow-hidden"
        sizes="200px"
      />
    </div>
  );
};

export default AppQRCode;
